import { doc, onSnapshot, setDoc } from 'firebase/firestore'
import { db } from '../lib/firebase'
import type { AdminSettings } from '../types/admin'

export const settingsDocRef = doc(db, 'settings', 'company')

export const defaultSettings: AdminSettings = {
  companyName: 'LYKKEVÆRK',
  tagline: 'Multiservice • Montage • Vedligehold',
  cvr: '46716825',
  phone: '',
  email: '',
  address: '',
  website: '',
  hourlyRate: '',
  callOutFee: '',
}

/** Lytter på settings/company, så alle besøgende ser de samme oplysninger med det samme. */
export function subscribeSettings(
  onChange: (settings: AdminSettings) => void,
  onError: (error: unknown) => void,
): () => void {
  return onSnapshot(
    settingsDocRef,
    (snapshot) => {
      const data = (snapshot.data() ?? {}) as Partial<AdminSettings>
      onChange({ ...defaultSettings, ...data })
    },
    onError,
  )
}

export async function saveSettingsToFirestore(settings: AdminSettings): Promise<void> {
  await setDoc(settingsDocRef, settings, { merge: true })
}
